import React from 'react';
import { FormSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useSeniorityFilter } from './useSeniorityFilter';

export const SeniorityFilter = ({ value, setFilters, seniorityOptions }) => {
  const {
    formSchema,
    onSubmit,
    seniorityOptions: options,
  } = useSeniorityFilter({
    setFilters,
    seniorityOptions,
  });

  const selectedOption = seniorityOptions.find((option) => option.value === value) || seniorityOptions[0];

  return (
    <Formik
      initialValues={{ seniority: selectedOption || '' }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="seniority"
          label="Seniority"
          placeholder="Seniority"
          size="small"
          component={FormSelect}
          options={options}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

SeniorityFilter.propTypes = {
  value: PropTypes.string,
  setFilters: PropTypes.func.isRequired,
  seniorityOptions: PropTypes.array.isRequired,
};

SeniorityFilter.defaultProps = {
  value: '',
};
